module.exports = __webpack_public_path__ + "static/media/2playerRoomsPlayed_25000_50000.41374cd3.png";